<template>
  <div
    :id="`app-${refId}`"
    class="web-camera-container">
    <div
      v-show="!finish && !isDisabled"
      class="camera-button">
      <b-button
        class="btn grey btn-import-form"
        @click="toggleCamera">
        <div v-if="!isCameraOpen">Open Camera</div>
        <div v-else>Close Camera</div>
      </b-button>
    </div>

    <div
      v-show="isCameraOpen && isLoading"
      class="camera-loading">
      <ul class="loader-circle">
        <li/>
        <li/>
        <li/>
      </ul>
    </div>

    <div
      v-if="isCameraOpen"
      v-show="!isLoading"
      :class="{ 'flash' : isShotPhoto }"
      class="camera-box">

      <div
        :class="{'flash' : isShotPhoto}"
        class="camera-shutter"/>

      <video
        v-show="!isPhotoTaken"
        ref="camera"
        :width="450"
        :height="337.5"
        autoplay/>

      <canvas
        v-show="isPhotoTaken"
        ref="canvas"
        :id="`photoTaken-${refId}`"
        :width="450"
        :height="337.5"/>
    </div>

    <b-row v-if="!finish">
      <b-col md="6">
        <div
          v-if="isCameraOpen && !isLoading"
          class="camera-shoot">
          <button
            type="button"
            class="button"
            @click="takePhoto">
            <img
              v-if="!isPhotoTaken"
              src="../../../assets/image/take-foto.png"
              width="45">
            <img
              v-if="isPhotoTaken"
              src="../../../assets/image/retake-foto.png"
              width="35">
          </button>
        </div>
      </b-col>
      <b-col md="6">
        <img
          v-if="isPhotoTaken && isCameraOpen"
          src="../../../assets/image/apply.png"
          class="m__t--13 cursor-pointer"
          width="65"
          @click="downloadImage">
      </b-col>
    </b-row>
    <img
      v-if="finish"
      src="../../../assets/image/apply-done.png"
      class="m__t--13"
      width="65">
      <!-- <div
      v-if="isCameraOpen && !isLoading"
      class="camera-shoot">
      <button
        type="button"
        class="button"
        @click="takePhoto">
        <img
          v-if="!isPhotoTaken"
          src="../../../assets/image/take-foto.png"
          width="45">
        <img
          v-if="isPhotoTaken"
          src="../../../assets/image/retake-foto.png"
          width="35">
      </button>
    </div> -->

      <!-- <div
      v-if="isPhotoTaken && isCameraOpen"
      class="camera-download">
      <a
        id="downloadPhoto"
        download="my-photo.jpg"
        class="button"
        role="button"
        @click="downloadImage">
        Download
      </a>
    </div> -->
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-console, no-unused-vars, no-eval */
import axios from 'axios';
import Vue from 'vue';

export default {
  props: {
    imgDefault: {
      type: String,
      default: '',
    },
    refId: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      link: '#',
      finish: false,
    };
  },
  methods: {
    toggleCamera() {
      if (this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },

    createCameraElement() {
      this.isLoading = true;
      // eslint-disable-next-line
      const constraints = (window.constraints = {
        audio: false,
        video: true,
      });


      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.isLoading = false;
          this.$refs.camera.srcObject = stream;
        })
        .catch((error) => {
          this.isLoading = false;
          // eslint-disable-next-line
          alert("May the browser didn't support or there is some errors.");
        });
    },

    stopCameraStream() {
      const tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach((track) => {
        track.stop();
      });
    },

    takePhoto() {
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;

      const context = this.$refs.canvas.getContext('2d');
      context.drawImage(this.$refs.camera, 0, 0, 450, 337.5);
    },

    downloadImage() {
      const download = document.getElementById('downloadPhoto');
      const canvas = document.getElementById(`photoTaken-${this.refId}`).toDataURL('image/jpeg')
        .replace('image/jpeg', 'image/octet-stream');
      // download.setAttribute('href', canvas);

      const token = Vue.ls.get('Token');
      const url = `${process.env.GATE_URL}/file/upload`;

      const commaPosition = canvas.lastIndexOf(',') + 1;
      const imageData = canvas.substring(commaPosition);
      const params = {
        content: imageData,
        filename: 'coba.jpg',
      };
      axios.post(url, params, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => {
        this.finish = true;
        this.stopCameraStream();
        this.$emit('set-url', res.data.data.url);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/hubungan-dinas/buku-tamu/jWebcamp.vue